<template>
  <keep-alive>
    <router-view :key="$route.fullPath"/>
  </keep-alive>
</template>


<script>

export default {
  name: "ComplexExercises",
  components: {},
  computed: {


  }
}
</script>

<style scoped lang="scss">
</style>
